import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeView,
    children:[

      {
        path: '/Manager/About',
        name:'本服简介',
        component: () => import('../views/Manager/AboutView.vue')
      },
      {
        path: '/Manager/Gonggao',
        name:'服务器公告',
        component: () => import('../views/Manager/GonggaoView.vue')
      },
      {
        path: '/Manager/Howjoin',
        name:'如何进服',
        component: () => import('../views/Manager/HowjoinView.vue')
      },
      {
        path: '/Manager/Afterlogin',
        name:'进服需知',
        component: () => import('../views/Manager/AfterloginView.vue')
      },
      {
        path: '/Manager/Epoch',
        name:'纪元攻略',
        component: () => import('../views/Manager/EpochView.vue')
      },
      {
        path: '/Manager/IPManage',
        name:'IP管理',
        component: () => import('../views/Manager/IPManageView.vue')
      },
      /*{
        path: '/Login',
        name:'IP登录',
        component: () => import('../views/LoginView')
      },*/
    ],
  },
  {
    path: '/EpochAdv',
    name:'纪元模组攻略',
    component: () => import('../views/EpochAdv.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
